/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import moment from 'moment';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { CHAT_ACTIONS } from '../../../../utils/constants/chat-actions';
import { openChat } from '../../../../store/brokers/partners/chats/ChatsUISlice';
import { tryToFetchTransactionsRuns } from '../../../../store/brokers/partners/transactions/transactionsSlice';
import { tryToFetchExecutiveStats } from '../../../../store/brokers/partners/admin/adminSlice';
import TabFilters from '../components/TabFilters';
import StackedBarChart from '../charts/StackedChart';
import PieChart from '../charts/PieChart';
import BarChart from '../charts/BarChart';
import NoDataOverlay from '../components/NoDataLayer';
import CardStackedBarChart from '../charts/CardStackedChart';
import { useGetCurrentUserQuery } from '../../../../store/user/userApi';


const ExecutiveTab = () => {
	const {data: user} = useGetCurrentUserQuery();
    const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });
    const dispatch = useAppDispatch();
    const [runsData, setRunsData] = useState<any>();
    const [selectedLatestRun, setSelectedLatestRun] = useState<any>();
    const [selectedDateRange, setSelectedDateRange] = useState<any>();
    const [specificDate, setSpecificDate] = useState<any>();
    const [reportingViewSelected, setReportingViewSelected] = useState<any>();
    const runs = useAppSelector((state) => state?.transactions?.runs)
    const stats = useAppSelector((state) => state?.admin?.executiveStats)

    useEffect(() => {
        if (runs) {
            const allRows = [...runsData || [], ...runs?.data?.elements || []]?.filter((item, index, self) =>
                index === self.findIndex((t) => t._id === item._id)
            );
            const formatRows = allRows && allRows?.length > 0 && allRows?.map((item: any, idx: number) => ({ ...item || {}, label: `Run #${runs?.data?.page?.totalElements - idx} - ${moment(item?.createdAt)?.format('DD/MM/YYYY')}`, value: item?.createdAt }))
            setRunsData(formatRows || [])
        }
    }, [runs])

    const getRunsData = async (showMore?: boolean, search?: string) => {
        try {
            const data: any = {
                pageNumber: showMore ? (runs?.data?.page?.number || 1) + 1 : 1,
                pageSize: 10,
                filters: search || undefined
            }
            await dispatch(tryToFetchTransactionsRuns(data)).unwrap();
        } catch (err) {
            console.error(err, 'error')
        }
    }

    const handleSearch = (query: string) => {
        getRunsData(false, query)
    };

    const getDateRange = (input: any) => {
        if (!input) return null;

        const formatDate = (dateStr: string, isStart: boolean): string => {
            const date = new Date(dateStr);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const time = isStart ? '00:00:00.000' : '23:59:59.999';
            return `${year}-${month}-${day}T${time}`;
        };

        if (Array.isArray(input) && input.length === 2) {
            const [start, end] = input;
            return {
                dateRangeMin: formatDate(start, true),
                dateRangeMax: formatDate(end, false),
            };
        }

        return {
            dateRangeMin: formatDate(input, true),
            dateRangeMax: formatDate(input, false),
        };
    };

    const onGettingStatsData = async (refresh?: boolean) => {
        try {

            let settingsFilters: any = {}
            if (!refresh) {
                if (selectedLatestRun && selectedLatestRun?.value !== 'all') {
                    settingsFilters = {
                        ...settingsFilters || {},
                        run: selectedLatestRun?.value
                    }
                }
                if (selectedDateRange && selectedDateRange?.value !== 'all') {
                    const range = getDateRange([selectedDateRange?.[0], selectedDateRange?.[1]]);
                    settingsFilters = {
                        ...settingsFilters || {},
                        dateRangeMin: range?.dateRangeMin,
                        dateRangeMax: range?.dateRangeMax
                    }
                }
                if (specificDate) {
                    const specificDateRange = getDateRange(specificDate);
                    settingsFilters = {
                        ...settingsFilters || {},
                        dateRangeMin: specificDateRange?.dateRangeMin,
                        dateRangeMax: specificDateRange?.dateRangeMax
                    }
                }
            }
            await dispatch(tryToFetchExecutiveStats(settingsFilters)).unwrap()
        } catch (err) {
            console.error(err)
        }
    }

    useEffect(() => {
        getRunsData()
        onGettingStatsData()
    }, [])

    const onOpenChat = () => {
        const formatUserRequest = {
            user: {
                message: CHAT_ACTIONS?.[0].text,
                files: [],
                sort: 2
            }
        };
        dispatch(openChat({ data: [formatUserRequest], action: CHAT_ACTIONS?.[0] }));
    }

    const onChangeReportingSelected = (value: any) => {
        setReportingViewSelected(value)
    }

    const onChangeFilters = (value: any, type: string) => {
        if (type === 'latestRun') {
            setSelectedLatestRun(value)
            setSpecificDate(undefined)
        }
        else {
            setSpecificDate(value)
            setSelectedLatestRun(undefined)
        }
        setSelectedDateRange(undefined)
    };

    const formatNumber = (value: number | string | null | undefined): any => {
        if (value === null || value === undefined || value === '') return 0;

        const num = typeof value === 'string' ? parseFloat(value) : value;
        if (isNaN(num)) return '';

        return num.toLocaleString('en-US');
    };

    // const formatNumberAmount = (value: number | string | null | undefined): any => {
    //     if (value === null || value === undefined || value === '') return 0;

    //     const num = typeof value === 'string' ? parseFloat(value) : value;
    //     if (isNaN(num)) return '';

    //     return num.toLocaleString('en-US');
    // };

    const onClickRefresh = () => {
        setSelectedDateRange(undefined)
        setSelectedLatestRun(undefined)
        setSpecificDate(undefined)
        onGettingStatsData(true)
    }

    const onChangeDateRange = (value: any) => {
        setSelectedDateRange(value)
        setSelectedLatestRun(undefined)
        setSpecificDate(undefined)
    }

    const onClickUpdateView = () => {
        onGettingStatsData()
    }

	const merged = [...stats?.transactionsByDepartment || []].reduce(
		(acc, curr) => {
		  if (curr.departmentName === "Others" || curr.departmentName === "BKF 7C") {
			acc.reconciled += curr.reconciled || 0;
			acc.voided += curr.voided || 0;
		  } else {
			acc.others.push(curr);
		  }
		  return acc;
		},
		{ reconciled: 0, voided: 0, others: [] }
	  );
	  
	  const transactionsByDepartment = user?.username === 'westworld' ? [
		...merged.others,
		{ departmentName: "Others", reconciled: merged.reconciled, voided: merged.voided },
	  ] : stats?.transactionsByDepartment;

    return (
        <div ref={ref}>
            <TabFilters
                allRuns={runsData || []}
                daysProcessed={stats?.reportSummary?.daysProcessed}
                from={stats?.reportSummary?.from}
                to={stats?.reportSummary?.to}
                specificDate={specificDate}
                selectedDateRange={selectedDateRange}
                selectedLatestRun={selectedLatestRun}
                hasNextPageRuns={runs?.data?.page?.hasNextPage}
                onChangeFilters={onChangeFilters}
                onChangeDateRange={onChangeDateRange}
                handleSearchRuns={handleSearch}
                onClickRefresh={onClickRefresh}
                onClickUpdate={onClickUpdateView}
                onLoadMore={() => getRunsData(true)}
            />
            <div className='my-3 flex flex-row items-center'>
                <p className='font-bold dark:text-primary-dark ml-2'>Report Data</p>
                {!(selectedLatestRun || selectedDateRange) && <p className='ml-2 dark:text-primary-dark'> - Latest Run</p>}
            </div>
            <div className='my-3 flex flex-row items-center'>
                <p className='font-bold dark:text-primary-dark ml-2'>Time Saved</p>
				<p className='ml-2 dark:text-primary-dark'>
                    {' '}
                    - {stats?.reportSummary?.timeSaved?.formatted || 0}
                </p>
            </div>
            <div className='grid grid-cols-1 md:grid-cols-1 gap-4'>
                <div className='px-4 py-3 h-full flex flex-col justify-between'>
                    <p className='font-bold mb-3 dark:text-primary-dark'>Match Rate</p>

                    <div className='grid md:grid-cols-2 grid-cols-1 gap-4 dark:text-primary-dark'>
                        <div className='border border-1 border-[#10B981] rounded-lg px-2 py-2 mb-2 dark:bg-black'>
                            <div className=''>
                                <div className='flex flex-row justify-between mb-2'>
                                    <img src='/assets/insights-tab/matched-icon.svg' className='object-contain h-[30px]' />
                                    <p className='text-[#10B981]'>{(stats?.reportSummary?.reconciled?.percentage || 0).toFixed(2)}%</p>
                                </div>
                                <div className='px-3'>
                                    <div className='grid grid-cols-3'>
                                        <p className='text-[#10B981] text-sm'>Total:</p>
                                        <p><span className='text-md text-[#10B981] mr-1'>{stats?.reportSummary?.reconciled?.count}</span>/ {stats?.reportSummary?.totalTransactions}</p>
                                        <p className='text-sm font-bold text-[#10B981] text-right'>€{formatNumber(stats?.reportSummary?.reconciled?.value || 0)}</p>
                                    </div>
                                    <div className='grid grid-cols-3 my-1'>
                                        <p className='text-sm'>POS:</p>
                                        <p className='text-sm'>{stats?.reportSummary?.reconciled?.pos?.count}</p>
                                        <p className='text-sm  text-right'>€{formatNumber(stats?.reportSummary?.reconciled?.pos?.value || 0)}</p>
                                    </div>
                                    <div className='grid grid-cols-3 my-1'>
                                        <p className='text-sm'>PSP:</p>
                                        <p className='text-sm'>{stats?.reportSummary?.reconciled?.psp?.count}</p>
                                        <p className='text-sm text-right'>€{formatNumber(stats?.reportSummary?.reconciled?.psp?.value || 0)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='border border-1 border-[#F59E0B] rounded-lg px-2 py-2 mb-2  dark:bg-black'>
                            <div className=''>
                                <div className='flex flex-row justify-between mb-2'>
                                    <img src='/assets/insights-tab/likely-matched-icon.svg' className='object-contain h-[30px]' />
                                    <p className='text-[#F59E0B]'>{(stats?.reportSummary?.potentiallyMatch?.percentage || 0).toFixed(2)}%</p>
                                </div>
                                <div className='px-3'>
                                    <div className='grid grid-cols-3'>
                                        <p className='text-[#F59E0B] text-sm'>Total:</p>
                                        <p><span className='text-md text-[#F59E0B] mr-1'>{stats?.reportSummary?.potentiallyMatch?.count}</span>/ {stats?.reportSummary?.totalTransactions}</p>
                                        <p className='text-sm font-bold text-[#F59E0B] text-right'>€{formatNumber(stats?.reportSummary?.potentiallyMatch?.value || 0)}</p>
                                    </div>
                                    <div className='grid grid-cols-3 my-1'>
                                        <p className='text-sm'>POS:</p>
                                        <p className='text-sm'>{stats?.reportSummary?.potentiallyMatch?.pos?.count}</p>
                                        <p className='text-sm  text-right'>€{formatNumber(stats?.reportSummary?.potentiallyMatch?.pos?.value || 0)}</p>
                                    </div>
                                    <div className='grid grid-cols-3 my-1'>
                                        <p className='text-sm'>PSP:</p>
                                        <p className='text-sm'>{stats?.reportSummary?.potentiallyMatch?.psp?.count}</p>
                                        <p className='text-sm text-right'>€{formatNumber(stats?.reportSummary?.potentiallyMatch?.psp?.value || 0)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='border border-1 border-[#EF4444] rounded-lg px-2 py-2 mb-2  dark:bg-black'>
                            <div className=''>
                                <div className='flex flex-row justify-between mb-2'>
                                    <img src='/assets/insights-tab/discrepancy-icon.svg' className='object-contain h-[30px]' />
                                    <p className='text-[#EF4444]'>{(stats?.reportSummary?.unreconciled?.percentage || 0).toFixed(2)}%</p>
                                </div>
                                <div className='px-3'>
                                    <div className='grid grid-cols-3'>
                                        <p className='text-[#EF4444] text-sm'>Total:</p>
                                        <p><span className='text-md text-[#EF4444] mr-1'>{stats?.reportSummary?.unreconciled?.count}</span>/ {stats?.reportSummary?.totalTransactions}</p>
                                        <p className='text-sm font-bold text-[#EF4444] text-right'>€{formatNumber(stats?.reportSummary?.unreconciled?.value || 0)}</p>
                                    </div>
                                    <div className='grid grid-cols-3 my-1'>
                                        <p className='text-sm'>POS:</p>
                                        <p className='text-sm'>{stats?.reportSummary?.unreconciled?.pos?.count}</p>
                                        <p className='text-sm  text-right'>€{formatNumber(stats?.reportSummary?.unreconciled?.pos?.value || 0)}</p>
                                    </div>
                                    <div className='grid grid-cols-3 my-1'>
                                        <p className='text-sm'>PSP:</p>
                                        <p className='text-sm'>{stats?.reportSummary?.unreconciled?.psp?.count}</p>
                                        <p className='text-sm text-right'>€{formatNumber(stats?.reportSummary?.unreconciled?.psp?.value || 0)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='border border-1 border-[#545863] rounded-lg px-2 py-2 mb-2 dark:bg-black'>
                            <div className=''>
                                <div className='flex flex-row justify-between mb-2'>
                                    <img src='/assets/insights-tab/voided-icon.svg' className='object-contain h-[30px]' />
                                    <p className='text-[#545863]'>{(stats?.reportSummary?.voided?.percentage || 0).toFixed(2)}%</p>
                                </div>
                                <div className='px-3'>
                                    <div className='grid grid-cols-3'>
                                        <p className='text-[#545863] text-sm'>Total:</p>
                                        <p><span className='text-md text-[#545863] mr-1'>{stats?.reportSummary?.voided?.count}</span>/ {stats?.reportSummary?.totalTransactions}</p>
                                        <p className='text-sm font-bold text-[#545863] text-right'>€{formatNumber(stats?.reportSummary?.voided?.value || 0)}</p>
                                    </div>
                                    <div className='grid grid-cols-3 my-1'>
                                        <p className='text-sm'>POS:</p>
                                        <p className='text-sm'>{stats?.reportSummary?.voided?.pos?.count}</p>
                                        <p className='text-sm  text-right'>€{formatNumber(stats?.reportSummary?.voided?.pos?.value || 0)}</p>
                                    </div>
                                    <div className='grid grid-cols-3 my-1'>
                                        <p className='text-sm'>PSP:</p>
                                        <p className='text-sm'>{stats?.reportSummary?.voided?.psp?.count}</p>
                                        <p className='text-sm text-right'>€{formatNumber(stats?.reportSummary?.voided?.psp?.value || 0)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='grid grid-cols-1 lg:grid-cols-1 gap-4 my-4'>
                <div className='col-span-1 lg:col-span-1 !rounded-lg border p-3'>
                    <p className='text-[#1C1C1C] dark:text-primary-dark font-semibold mb-5'>Total Transactions by department</p>
                    {inView && (
                        <StackedBarChart
                            data={transactionsByDepartment || []}
                            departments={transactionsByDepartment?.length > 0 ? transactionsByDepartment?.map((item: any) => item?.departmentName) : []}
                        />
                    )}
                </div>
            </div>
            <div className='grid grid-cols-1 lg:grid-cols-1 gap-4 my-4'>
                <div className='col-span-1 lg:col-span-1 !rounded-lg border p-3'>
                    <p className='text-[#1C1C1C] dark:text-primary-dark font-semibold mb-5'>Transaction by Card Issuer</p>
                    {inView &&
                        <CardStackedBarChart
                            data={stats?.transactionsByCardIssuer}
                        />
                        // <BarChart
                        //     xAxisData={stats?.transactionsByCardIssuer && stats?.transactionsByCardIssuer?.length > 0 ? stats?.transactionsByCardIssuer?.map((item: any) => formatText(item?.cardIssuer)) : []}
                        //     chartData={stats?.transactionsByCardIssuer && stats?.transactionsByCardIssuer?.length > 0 ? stats?.transactionsByCardIssuer?.map((item: any) => item?.count) : []}
                        //     amountData={stats?.transactionsByCardIssuer && stats?.transactionsByCardIssuer?.length > 0 ? stats?.transactionsByCardIssuer?.map((item: any) => item?.value) : []}
                        // />
                    }
                </div>
            </div>
            <div className='grid grid-cols-1 lg:grid-cols-8 gap-4 my-4'>
                <div className='col-span-1 lg:col-span-4 !rounded-lg border p-3'>
                    <p className='text-[#1C1C1C] dark:text-primary-dark font-semibold mb-5'>Donut Graph match performance (by count)</p>
                    <PieChart
                        data={[
                            { name: 'Reconciled', value: stats?.reportSummary?.reconciled?.count, show: '' },
                            { name: 'Potential Match', value: stats?.reportSummary?.potentiallyMatch?.count, show: '' },
                            { name: 'Unreconciled', value: stats?.reportSummary?.unreconciled?.count, show: '' },
                            { name: 'Voided', value: stats?.reportSummary?.voided?.count, show: '' },
                        ]}
                    />
                </div>
                <div className='col-span-1 lg:col-span-4 !rounded-lg border p-3'>
                    <p className='text-[#1C1C1C] dark:text-primary-dark font-semibold mb-5'>Donut Graph match performance (by value)</p>
                    <PieChart
                        data={[
                            { name: 'Reconciled', value: (stats?.reportSummary?.reconciled?.value || 0).toFixed(2), show: '€' },
                            { name: 'Potential Match', value: (stats?.reportSummary?.potentiallyMatch?.value || 0).toFixed(2), show: '€' },
                            { name: 'Unreconciled', value: (stats?.reportSummary?.unreconciled?.value || 0).toFixed(2), show: '€' },
                            { name: 'Voided', value: (stats?.reportSummary?.voided?.value || 0).toFixed(2), show: '€' },
                        ]}
                    />
                </div>
            </div>
        </div >
    )
}
export default ExecutiveTab;